import Vue from 'vue'
import App from './App.vue'
import router, { setupGlobalErrorHandling } from './router'
import store from './store'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import './assets/css/tailwind.css'
import MessagePlugin from './plugins/message'
import { getImageUrl, getImageUrls, getThumbnailUrl } from './utils/imageUrl'

Vue.config.productionTip = false

// 配置Toast
Vue.use(Toast, {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false
})

// 配置 $message 插件
Vue.use(MessagePlugin)

// 全局图片URL处理方法
Vue.prototype.$getImageUrl = getImageUrl
Vue.prototype.$getImageUrls = getImageUrls
Vue.prototype.$getThumbnailUrl = getThumbnailUrl

// 全局过滤器：图片URL处理
Vue.filter('imageUrl', getImageUrl)

// 初始化用户状态（从localStorage恢复token）
store.dispatch('initUserState')

// 设置全局错误处理
setupGlobalErrorHandling()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
